import { render, staticRenderFns } from "./CAddMangosHours.vue?vue&type=template&id=30781f8d"
import script from "./CAddMangosHours.vue?vue&type=script&lang=js"
export * from "./CAddMangosHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports